import { createContext, useContext, useState, useEffect, useCallback } from "react";
import API, { setAuthToken, clearAuthToken, getStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getStoredToken();
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await API.get("/auth/me");
      setUser(data.user);
    } catch {
      // Point 5: don't force-logout on a transient/expired access token — try a
      // silent refresh first (cookie-based refresh token is long-lived). Only log
      // the user out if the refresh also fails.
      try {
        const { data: r } = await API.post("/auth/refresh");
        if (r.access_token) setAuthToken(r.access_token);
        const { data } = await API.get("/auth/me");
        setUser(data.user);
      } catch {
        clearAuthToken();
        setUser(false);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = (userData, token) => {
    if (token) setAuthToken(token);
    setUser(userData);
  };
  const logout = async () => {
    try { await API.post("/auth/logout"); } catch {}
    clearAuthToken();
    setUser(false);
  };
  const refreshUser = async () => {
    try {
      const { data } = await API.get("/auth/me");
      setUser(data.user);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
